/* eslint-disable */

const ruminant = [
  { title: 'Barley (Treated)', efValue: 0.28 },
  { title: 'Barley (Dried)', efValue: 0.36 },
  { title: 'Barley (Aerated)', efValue: 0.38 },
  { title: 'Beans (Treated)', efValue: 0.23 },
  { title: 'Beans (Dried)', efValue: 0.28 },
  { title: 'Beet Pulp', efValue: 0.06 },
  { title: 'Cane Molasses', efValue: 0.15 },
  { title: 'Citrus Pulp (USA)', efValue: 0.06 },
  { title: 'Corn gluten (USA)', efValue: 0.34 },
  { title: 'DDGS (USA)', efValue: 0.36 },
  { title: 'Limestone', efValue: 0.15 },
  { title: 'Lysine', efValue: 8.25 },
  { title: 'Magnesium Oxide CalMag', efValue: 0 },
  { title: 'Maize (Imported)', efValue: 0.45 },
  { title: 'Maize Gluten Feed', efValue: 0.34 },
  { title: 'Molasses Blend', efValue: 0.15 },
  { title: 'Palm kern meal (Malaysian)', efValue: 0.41 },
  { title: 'Pollard', efValue: 0.64 },
  { title: 'Rapeseed Extraction', efValue: 0.4 },
  { title: 'Rapeseed meal (French)', efValue: 0.4 },
  { title: 'Sodium Bicarbonate', efValue: 1.29 },
  { title: 'Sodium chloride', efValue: 0.09 },
  { title: 'Soyabean hulls (USA)', efValue: 0.01 },
  { title: 'Soyabean meal (USA)', efValue: 0.32 },
  { title: 'Soybean hulls (Brazilian)', efValue: 0.28 },
  { title: 'Soybean meal (Brazilian)', efValue: 11.65 },
  { title: 'Sunflower Meal (French)', efValue: 2.15 },
  { title: 'Threonine', efValue: 3.77 },
  { title: 'Wheat (Treated)', efValue: 0.28 },
  { title: 'Wheat (Dried)', efValue: 0.37 },
  { title: 'Wheat (Aerated)', efValue: 0.02 },
  { title: 'Wheat bran', efValue: 0.37 },
  { title: 'Wheatfeed (Native)', efValue: 0.37 },
];

const monogastric = [
  { title: 'Barley (Treated)', efValue: 0.28 },
  { title: 'Barley (Dried)', efValue: 0.36 },
  { title: 'Barley (Aerated)', efValue: 0.38 },
  { title: 'Beans (Treated)', efValue: 0.23 },
  { title: 'Beans (Dried)', efValue: 0.28 },
  { title: 'Beet Pulp', efValue: 0.06 },
  { title: 'Calcium carbonate', efValue: 0 },
  { title: 'Cane Molasses', efValue: 0.15 },
  { title: 'Limestone', efValue: 0.15 },
  { title: 'Lysine', efValue: 8.25 },
  { title: 'Maize (Imported)', efValue: 0.45 },
  { title: 'Methionine', efValue: 2.52 },
  { title: 'Molasses Blend', efValue: 0.15 },
  { title: 'Rapeseed Extraction', efValue: 0.4 },
  { title: 'Sodium Bicarbonate', efValue: 1.29 },
  { title: 'Sodium chloride', efValue: 0.09 },
  { title: 'Soya Oil (Brazilian)', efValue: 0.53 },
  { title: 'Soybean hulls (Brazilian)', efValue: 0.28 },
  { title: 'Soybean meal (Brazilian)', efValue: 11.65 },
  { title: 'Threonine', efValue: 3.77 },
  { title: 'Wheat (Treated)', efValue: 0.28 },
  { title: 'Wheat (Dried)', efValue: 0.37 },
  { title: 'Wheat (Aerated)', efValue: 0.02 },
  { title: 'Wheat bran', efValue: 0.37 },
  { title: 'Wheatfeed (Native)', efValue: 0.37 },
];

export default { ruminant, monogastric };
